import { useMemo } from 'react';
import {
  FontAwesomeIcon,
  GrcTextBox,
  GrcTooltip,
  GrcTooltipPosition,
  IconProp,
  facircleinfoclassicregular
} from '@grc/ui-package';
import { formatDate } from '@grc/ui-utility';
import { useI18nState } from '../../../stores/settings/language-context';
import DateRangeFilter from '../../../common/date-range-filter/date-range-filter';
import { IDateRangeFilterValue } from '../../../common/date-range-filter/date-range-filter.interface';
import './quote-toolbar.scss';

interface IQuoteToolbarProps {
  searchText: string;
  onSearchTextChange: (value: string) => void;
  dateFilter: IDateRangeFilterValue;
  onDateFilterChange: (value: IDateRangeFilterValue) => void;
}

export default function QuoteToolbar({
  searchText,
  onSearchTextChange,
  dateFilter,
  onDateFilterChange
}: IQuoteToolbarProps) {
  const { localeData } = useI18nState();
  const { fromDate, toDate } = dateFilter;

  const dateRangeLabel = useMemo(
    () =>
      fromDate.toDateString() === toDate.toDateString()
        ? formatDate(fromDate)
        : `${formatDate(fromDate)} - ${formatDate(toDate)}`,
    [fromDate, toDate]
  );

  return (
    <div className="quote-toolbar" data-testid="quote_toolbar">
      <div className="quote-toolbar-search position-relative">
        <GrcTextBox
          placeholder={localeData.SearchByQuoteId}
          value={searchText}
          mode="search"
          onValueChange={(e: any) => onSearchTextChange(e ?? '')}
        />
      </div>

      <span className="quote-toolbar-date-label">{dateRangeLabel}</span>

      <div className="quote-toolbar-right d-flex align-items-center">
        <DateRangeFilter
          idPrefix="quoteManagement"
          value={dateFilter}
          onChange={onDateFilterChange}
        />
        <GrcTooltip
          title={localeData.QuoteManagementInfoTooltip}
          position={GrcTooltipPosition.Top}
        >
          <span
            className="quote-toolbar-info ms-2"
            role="img"
            aria-label={localeData.QuoteManagementInfoTooltip}
          >
            <FontAwesomeIcon icon={facircleinfoclassicregular as IconProp} />
          </span>
        </GrcTooltip>
      </div>
    </div>
  );
}
